import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import * as SC from "./PrintPostEditorYoutube.styled";
import * as VerticalSC from "./../../../../Previews/PostEditors/post-editor-vertical/PostEditorVertical.styled";
import logger from "../../../../../../utils/LoggerFrontend";

import PrintCampaignCreateTeaserEditor from "../../print-campaign-create-teaser-editor/PrintCampaignCreateTeaserEditor";
import PrintCampaignCreateChannelDataEditor from "../../print-channel-editor/PrintCampaignCreateChannelDataEditor";
import PrintTemplateEditor from "../../print-campaign-template-editor/PrintTemplateEditor";

import { ForwardIcon } from "../../../../Previews/Svg";
import { channelsByShortName } from "../../../../../../data/app__channels";
import { Tooltip } from "../../../../Previews/Components";
import { GreyBar } from "../../../../Previews/PostEditors/post-editor-youtube/PostEditorYoutube";
import { VERTICAL_TEMPLATE_IDS } from "../../../../Previews/constants";

import {
  IMAGE_TEMPLATES_INFO,
  VIDEO_TEMPLATES_INFO
} from "@talentbait/remotion-templates-talentbait";

const allTemplatesInfo = { ...IMAGE_TEMPLATES_INFO, ...VIDEO_TEMPLATES_INFO };

const PrintPostEditorYoutube = ({
  campaignId,
  postData,
  channelData,
  mobile,
  editable,
  channel,
  selectedCreativeIndexToEdit,
  mediaAssets,
  mediaAssetsProps
}) => {
  const { t } = useTranslation();

  const selectedCreative = useMemo(
    () => postData.creatives?.[selectedCreativeIndexToEdit],
    [postData.creatives, selectedCreativeIndexToEdit]
  );

  logger.log("PostEditorYoutube:render", "render:", {
    postData,
    channelData,
    mobile,
    editable,
    channel,
    mediaAssets,
    selectedCreative,
    selectedCreativeIndexToEdit,
    campaignId
  });

  const { inputProps, templateId } = mediaAssetsProps[selectedCreativeIndexToEdit] || {};

  const template = allTemplatesInfo[templateId];

  const multiTemplatesOrientation =
    template?.orientation === "multi" && inputProps?.orientation === "vertical";

  const verticalTemplate =
    VERTICAL_TEMPLATE_IDS.includes(template?.id) || multiTemplatesOrientation;

  const templateSC = verticalTemplate ? VerticalSC.VERTICAL_IMAGE_SPEC : SC.YOUTUBE_IMAGE_SIZE_SPEC;

  const minAspect = verticalTemplate ? templateSC.minAspect : channelsByShortName.youtube.minAspect;
  const maxAspect = verticalTemplate ? templateSC.maxAspect : channelsByShortName.youtube.maxAspect;

  const templatePreviewSizes = {
    minHeight: templateSC.minHeight,
    maxHeight: templateSC.maxHeight,
    width: templateSC.pictureWidth,
    minAspect: minAspect,
    maxAspect: maxAspect
  };

  const logoUrl =
    channel === "youtube"
      ? "/images/youtube_logo_preview.png"
      : channel === "google-display"
      ? "/images/google_logo_preview.png"
      : "/images/ebay_kleinanzeigen_logo_preview.png";

  return (
    <SC.PostEditorWrapper mobile={mobile} verticalTemplate={verticalTemplate}>
      <SC.HeaderWrapper>
        <SC.Logo src={logoUrl} alt="" />
      </SC.HeaderWrapper>
      <SC.BodyWrapper>
        {!verticalTemplate && <GreyBar number={3} />}
        <SC.Editor verticalTemplate={verticalTemplate}>
          <PrintTemplateEditor
            selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
            mediaAssets={mediaAssets}
            mediaAssetsProps={mediaAssetsProps}
            templateType="image"
            creatives={postData.creatives}
            creativeAssets={postData.creativeAssets}
            channel={channel}
            templatePreviewSizes={templatePreviewSizes}
          />

          <SC.TitleWrapper>
            <PrintCampaignCreateChannelDataEditor
              value={channelData.title}
              dataKey="title"
              textStyle={SC.titleStyle}
              limit={channelsByShortName[channel].limits.title}
              label={t("Job Title")}
              tooltip={t("Job Title")}
              editable={editable}
              dark
              bannedCharaters={["!", "<", ">"]}
            />
          </SC.TitleWrapper>
          <SC.DescriptionWrapper>
            <SC.EditorWrapper>
              <PrintCampaignCreateTeaserEditor
                channel={channel}
                teaserText={postData.teaserText}
                editable={editable}
                teaserTextStyle={SC.teaserTextStyle}
                limit={channelsByShortName[channel].limits.teaserText}
                minRows={2}
                smallButtons
                disableEmojis={true}
                bannedCharaters={["!", "<", ">"]}
                isAutoGenerated={postData?.isAutoGenerated}
                autoGeneratedText={postData?.autoGeneratedText}
                isEdited={postData?.editedStates?.teaserText}
                rejectUppercaseWords={true}
                uppercaseWhitelist={["PKW", "LKW", "IMS", "SAP"]}
              />
            </SC.EditorWrapper>
            <SC.EditorFooter>
              <SC.CompanyNameWrapper>
                <PrintCampaignCreateChannelDataEditor
                  value={channelData.companyName}
                  dataKey="companyName"
                  textStyle={SC.companyNameStyle}
                  limit={channelsByShortName[channel].limits.companyName}
                  label={t("Company Name")}
                  tooltip={t("Company Name")}
                  editable={editable}
                />
                <SC.Sponsored data-tip="" data-for="youtube-sponsored-tooltip">
                  {t("Sponsored")}
                </SC.Sponsored>
                <Tooltip
                  id="youtube-sponsored-tooltip"
                  effect="solid"
                  place="top"
                  backgroundColor="#1C1928"
                  offset={{ top: -5 }}
                >
                  {t("Playout as sponsored advertisement")}
                </Tooltip>
              </SC.CompanyNameWrapper>
              <SC.ArrowButton target="_blank" href={channelData.url}>
                <ForwardIcon style={{ width: "100%" }} />
              </SC.ArrowButton>
            </SC.EditorFooter>
          </SC.DescriptionWrapper>
        </SC.Editor>
        {!verticalTemplate && <GreyBar number={2} />}
      </SC.BodyWrapper>
    </SC.PostEditorWrapper>
  );
};

export default PrintPostEditorYoutube;
